import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '../../commons/component/PageHeader/PageHeader';
import FilesExplorerComponent from '../../components/Files/FilesExplorer/FilesExplorer.Component';
import { normalizeStoragePath } from '../../functions/StorageBrowser.Functions';

const usePageStyles = makeStyles({
  page: {
    minHeight: '100%',
    boxSizing: 'border-box',
    backgroundColor: tokens.colorNeutralBackground2,
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalXXL, tokens.spacingVerticalXXXL),
    '@media (max-width: 720px)': {
      ...shorthands.padding(tokens.spacingVerticalM, tokens.spacingHorizontalL, tokens.spacingVerticalXXL),
    },
  },
});

/**
 * "Ver archivos": OneDrive-like explorer of the tenant Azure Storage.
 * The folder lives in the URL (/files?path=proveedor_45/ProviderInvoice) so deep links work
 * and the browser back button moves between folders.
 */
export const FilesExplorerPage = () => {
  const { t } = useTranslation();
  const styles = usePageStyles();
  const [searchParams, setSearchParams] = useSearchParams();

  const path = normalizeStoragePath(searchParams.get('path'));

  const navigateToFolder = React.useCallback(
    (nextPath: string, options?: { replace?: boolean }) => {
      const normalized = normalizeStoragePath(nextPath);
      if (normalized === path) return;
      // After renaming the folder being shown the URL is replaced (the old path no longer exists).
      setSearchParams(normalized ? { path: normalized } : {}, { replace: !!options?.replace });
    },
    [path, setSearchParams]
  );

  return (
    <>
      <PageHeader eyebrow={t('filesExplorer.eyebrow')} title={t('filesExplorer.title')} />
      <div className={styles.page}>
        <FilesExplorerComponent path={path} onNavigate={navigateToFolder} />
      </div>
    </>
  );
};

export default FilesExplorerPage;
